import React, { useEffect, useState } from 'react';
import { MapPin, Menu, X } from 'lucide-react';
import { navLinks } from '../data/mock';
import { Button } from './ui/button';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#0b2f5c]/95 backdrop-blur-md shadow-lg py-3'
          : 'bg-[#0b2f5c] py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button onClick={() => scrollTo('#home')} className="flex items-center gap-2 group">
          <div className="relative">
            <div className="absolute inset-0 bg-sky-400 blur-lg opacity-40 group-hover:opacity-70 transition-opacity" />
            <div className="relative w-9 h-9 rounded-full bg-gradient-to-br from-sky-300 to-sky-500 flex items-center justify-center shadow-lg">
              <MapPin className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
          </div>
          <span className="text-2xl font-bold text-white tracking-tight">
            Ma<span className="text-sky-300">Life</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="text-sm font-medium text-white/80 hover:text-sky-300 transition-colors relative group"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-sky-300 group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button
            onClick={() => scrollTo('#download')}
            className="bg-sky-400 hover:bg-sky-300 text-[#0b2f5c] font-semibold rounded-full px-6 shadow-md hover:shadow-sky-400/30 transition-all"
          >
            Get the App
          </Button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0b2f5c] border-t border-white/10 mt-3">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="text-left text-white/90 hover:text-sky-300 py-2 text-sm font-medium"
              >
                {link.label}
              </button>
            ))}
            <Button
              onClick={() => scrollTo('#download')}
              className="bg-sky-400 hover:bg-sky-300 text-[#0b2f5c] font-semibold rounded-full"
            >
              Get the App
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
